import React from "react";
import { Modal, ModalBody } from "reactstrap";
import moment from "moment";
import scheduleSuccessImage from "assets/images/assessment-scheduled-graphics.svg";

export const ScheduleSuccessfullModal = ({
  isOpen,
  onCancel,
  onConfirm,
  data,
  ...rest
}) => {
  return (
    <Modal
      isOpen={isOpen}
      className="common-modal modal__assessment_schedule"
      {...rest}
    >
      <ModalBody>
        <div className="common-modal-content">
          <img src={scheduleSuccessImage} alt="" className="modal-icon" />
          <p className="modal-sm-txt">
            Your Assessment Scheduled Successfully!
          </p>
          <p className="modal-bold-txt">
            {moment(data?.scheduledDate, "DD-MMM-YYYY").format("MMMM DD YYYY")}
          </p>
          <p className="modal-bold-txt">
            {`${data?.startAtStr} - ${data?.endAtStr}`}
          </p>
          <div className="modal-action">
            <button className="btn btn-blue" onClick={onConfirm}>
              Ok
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
